import React from 'react';
import "./styles.css";

function FullPageLoader() {
    return(
        <div className="fullPageLoader">
            <div className="loadingSpinner"></div>
            <span className="loadingTitle">Loading...</span>
        </div>
    )
}
export default FullPageLoader;